module.exports = __webpack_public_path__ + "static/media/Skywrath Mage.d09f38a8.png";